<template>
  <div>
    <tk-flex  between >
      <public-header :title="'排名活动详情'" show-back></public-header>
    </tk-flex>
    <a-spin :spinning="loading" class="full-width" style="min-height: 60vh;" >
      <div style="display: none;">.</div>
      <div class="full-width bg-white border-radius-12 p-24" v-if="pageData && pageData.objectId" >
        <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
        <div v-show="key === 0" style="height:100%">
          <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              类型：{{ pageData.type === '0' ? '地区' : '全国' }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  v-if="pageData.type === '0'">
              <a-tooltip>
                <template slot="title">
                  {{agentList}}
                </template>
                代理商：代理商({{pageData.agent.length}})
              </a-tooltip>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              活动开始时间：{{ pageData.startDate | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              活动结束时间：{{ pageData.endDate | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              <tk-flex>
                活动详情图：
                <viewer v-if="pageData.detailPicture" :images="[pageData.detailPicture]">
                  <img :src="pageData.detailPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                </viewer>
                <span v-else>-</span>
              </tk-flex>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              <tk-flex>
                Banner图：
                <viewer v-if="pageData.popupPicture" :images="[pageData.popupPicture]">
                  <img :src="pageData.popupPicture" style="width: 120px;height: 120px;border: 1px solid #E1E4EB;border-radius: 7px;object-fit: contain;" />
                </viewer>
                <span v-else>-</span>
              </tk-flex>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              是否开启：{{ pageData.isClose ? '否' : '是' }}
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>

  </div>
</template>
<script>
import publicHeader from '../../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      menuList: [
        {
          name: '基本信息'
        }
      ],
      key: 0,
      id: null,
      filters: {},
      agentList: ''
    }
  },
  // 监听页面id的变化
  watch: {
    $route (to, from) {
      this.init()
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        this.filters.marketingCampaign = this.id
        await this.getData()
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 获取数据
    async getData () {
      const { data } = await this.$tkParse.get(`/classes/marketingCampaign/${this.$route.query.id}`, {
        params: { include: 'series,voltage,capacity,gift' }
      })
      console.log(data)
      this.pageData = data
      if (data.type === '0') {
        let { data: user } = await this.$tkParse.get(`/classes/_User`, {
          params: {
            keys: 'nickName',
            limit: data.agent.length,
            where: {
              objectId: {
                $in: data.agent
              }
            }
          }
        })
        let arr = user.results.map(item => {
          return item.nickName
        })
        this.agentList = arr.join('、')
      }
    },
    // 刷新商品
    refresh () {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
